import {
  CLEAR_STATE,

  GET_AGM_PRESENCE,
  GET_AGM_PRESENCE_ERROR,
  GET_AGM_PRESENCE_SUCCESS,

  GET_PRESENCE,
  GET_PRESENCE_ERROR,
  GET_PRESENCE_SUCCESS,

  // SAVE_AGM_PRESENCE,
  // SAVE_AGM_PRESENCE_ERROR,
  // SAVE_AGM_PRESENCE_SUCCESS,

  DELETE_AGM_PRESENCE,
  DELETE_AGM_PRESENCE_ERROR,
  DELETE_AGM_PRESENCE_SUCCESS,

  DOWNLOAD_AGM_PRESENCE,
  DOWNLOAD_AGM_PRESENCE_ERROR,
  DOWNLOAD_AGM_PRESENCE_SUCCESS,

  UPDATE_AGM_PRESENCE,
  UPDATE_AGM_PRESENCE_ERROR,
  UPDATE_AGM_PRESENCE_SUCCESS,

} from './constants';

export default {
  [CLEAR_STATE](state) {
    state.error = false;
    state.success = false;
  },

  [DOWNLOAD_AGM_PRESENCE](state) {
    state.downloadLink = '';
    state.exportSuccess = false;
    state.error = false;
    state.exportLoading = true;
  },
  [DOWNLOAD_AGM_PRESENCE_ERROR](state, payload) {
    state.error = payload;
    state.exportLoading = false;
  },
  [DOWNLOAD_AGM_PRESENCE_SUCCESS](state, payload) {
    state.downloadLink = payload;
    state.exportLoading = false;
    state.exportSuccess = true;
  },

  [GET_AGM_PRESENCE](state) {
    state.success = false;
    state.error = false;
    state.loading = true;
  },
  [GET_AGM_PRESENCE_ERROR](state, payload) {
    state.error = payload;
    state.loading = false;
  },
  [GET_AGM_PRESENCE_SUCCESS](state, payload) {
    if (payload.agmPresence === null) {
      return;
    }
    state.agmPresence = payload.agmPresence
      .map((data, index) => ({ ...data, quotePart: `${data.quotePart}%`, originalIndex: index }))
      .sort((a, b) => {
        const parseUnit = (unit) => {
          if (!unit || typeof unit !== 'string') {
            return {
              prefix: '',
              number: null,
              letter: '',
              suffixNumber: null,
              hasHyphen: false,
            };
          }

          // Match alphanumeric structure with or without hyphens
          let match = unit.match(/^([A-Za-z\s]*)(\d*)(-?)([A-Za-z]*)(\d*)$/);
          if (!match) {
            match = unit.match(/^([A-Za-zÀ-ÿ\s]*)(\d+)?(?:-(\d+))?\s*([A-Za-z]*)?(\d*)$/);
          }
          return {
            prefix: match[1] ? match[1].trim() : '',
            number: match[2] ? parseInt(match[2], 10) : null,
            hasHyphen: match[3] === '-',
            letter: match[4] || '',
            suffixNumber: match[5] ? parseInt(match[5], 10) : null,
          };
        };

        const unitA = parseUnit(a.unit);
        const unitB = parseUnit(b.unit);

        // Step 2: Compare alphabetic prefix (e.g., 'Bruxceel' vs '85')
        const prefixComparison = unitA.prefix.localeCompare(unitB.prefix);
        if (prefixComparison !== 0) return prefixComparison;

        // Step 3: Compare numeric part if both units have a prefix
        if (unitA.number !== unitB.number) {
          return (unitA.number || 0) - (unitB.number || 0);
        }

        // Step 4: Compare the letter part (e.g., '85A' vs '85B')
        const letterComparison = unitA.letter.localeCompare(unitB.letter);
        if (letterComparison !== 0) return letterComparison;

        // Step 5: Compare suffix numbers (e.g., '85-1' vs '85-2')
        if (unitA.suffixNumber !== unitB.suffixNumber) {
          return (unitA.suffixNumber || 0) - (unitB.suffixNumber || 0);
        }

        return 0;
      });
    state.totalQuotePart = payload.totalQuotePart;
    state.loading = false;
  },

  [GET_PRESENCE](state) {
    state.success = false;
    state.error = false;
    state.loading = true;
  },
  [GET_PRESENCE_ERROR](state, payload) {
    state.error = payload;
    state.loading = false;
  },
  [GET_PRESENCE_SUCCESS](state, payload) {
    state.presence = payload;
    state.success = true;
    state.loading = false;
  },

  [UPDATE_AGM_PRESENCE](state) {
    state.error = false;
    state.success = false;
    state.formLoading = true;
  },
  [UPDATE_AGM_PRESENCE_ERROR](state, payload) {
    state.error = payload;
    state.success = false;
    state.formLoading = false;
  },
  [UPDATE_AGM_PRESENCE_SUCCESS](state, payload) {
    state.agmPresence = payload.agmPresence
      .map((data, index) => ({ ...data, quotePart: `${data.quotePart}%`, originalIndex: index }))
      .sort((a, b) => {
        const parseUnit = (unit) => {
          if (!unit || typeof unit !== 'string') {
            return {
              prefix: '',
              number: null,
              letter: '',
              suffixNumber: null,
              hasHyphen: false,
            };
          }

          // Match alphanumeric structure with or without hyphens
          let match = unit.match(/^([A-Za-z\s]*)(\d*)(-?)([A-Za-z]*)(\d*)$/);
          if (!match) {
            match = unit.match(/^([A-Za-zÀ-ÿ\s]*)(\d+)?(?:-(\d+))?\s*([A-Za-z]*)?(\d*)$/);
          }
          return {
            prefix: match[1] ? match[1].trim() : '',
            number: match[2] ? parseInt(match[2], 10) : null,
            hasHyphen: match[3] === '-',
            letter: match[4] || '',
            suffixNumber: match[5] ? parseInt(match[5], 10) : null,
          };
        };

        const unitA = parseUnit(a.unit);
        const unitB = parseUnit(b.unit);

        // Step 2: Compare alphabetic prefix (e.g., 'Bruxceel' vs '85')
        const prefixComparison = unitA.prefix.localeCompare(unitB.prefix);
        if (prefixComparison !== 0) return prefixComparison;

        // Step 3: Compare numeric part if both units have a prefix
        if (unitA.number !== unitB.number) {
          return (unitA.number || 0) - (unitB.number || 0);
        }

        // Step 4: Compare the letter part (e.g., '85A' vs '85B')
        const letterComparison = unitA.letter.localeCompare(unitB.letter);
        if (letterComparison !== 0) return letterComparison;

        // Step 5: Compare suffix numbers (e.g., '85-1' vs '85-2')
        if (unitA.suffixNumber !== unitB.suffixNumber) {
          return (unitA.suffixNumber || 0) - (unitB.suffixNumber || 0);
        }

        return 0;
      });

    state.totalQuotePart = payload.totalQuotePart;
    state.loading = false;
  },

  [DELETE_AGM_PRESENCE](state) {
    state.success = false;
    state.error = false;
    state.loading = true;
  },
  [DELETE_AGM_PRESENCE_ERROR](state, payload) {
    state.error = payload;
    state.loading = false;
  },
  [DELETE_AGM_PRESENCE_SUCCESS](state) {
    state.success = true;
    state.agmPresence = false;
    state.loading = false;
  },

  // single object item mutation
  updateItem(state, payload) {
    state.agmPresence[payload.item] = payload.value;
  },
};



// WEBPACK FOOTER //
// ./src/components/Syndicates/Syndicate/Reports/AGM/mutations.js